import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  clearLabsEnabled,
  isLabsEnabledThisSession,
  persistLabsEnabled,
} from '@vaiu/utils';

interface LabsRouteProps {
  children: React.ReactNode;
}

/**
 * First visit with `?labs=on` unlocks labs for this tab (sessionStorage).
 * Later lab routes do not need the query string. `?labs=off` turns them off.
 */
const LabsRoute: React.FC<LabsRouteProps> = ({ children }) => {
  const location = useLocation();
  const labsFlag = new URLSearchParams(location.search).get('labs');

  if (labsFlag === 'off') {
    clearLabsEnabled();
    return <Navigate to="/" replace />;
  }

  if (labsFlag === 'on') {
    persistLabsEnabled();
    return <>{children}</>;
  }

  if (isLabsEnabledThisSession()) {
    return <>{children}</>;
  }

  return <Navigate to="/" replace />;
};

export default LabsRoute;
